export default "/_nuxt/2f37e38f2708810f2badd48b3fe0f665.svg";